import requestApi from "../common/boxp_api_client";
import requestrApi from "../common/boxr_api_client";

const getBaseStation = (params) => {
  return requestApi({
    url: "/base-stations",
    method: "GET",
    params,
  });
};

const getReportsTableData = (params) => {
  return requestApi({
    url: "/sms/mysms/myreports",
    method: "GET",
    params,
  });
};
const getInputsTableData = (params) => {
  return requestApi({
    url: "/sms/mysms/myinputs",
    method: "GET",
    params,
  });
};
const getTasksTableData = (params) => {
  return requestApi({
    url: "/sms/mysms/mytasks",
    method: "GET",
    params,
  });
};
const getManagedTasksTableData = (params) => {
  return requestApi({
    url: "/sms/mysms/mymanagedtasks",
    method: "GET",
    params,
  });
};
const getHeaderOverviewData = (params) => {
  return requestApi({
    url: "sms/mysms/overview",
    method: "GET",
    params,
  });
};

const getRegulatorsList = (params) => {
  return requestApi({
    url: "sms/get_regulators",
    mathod: "GET",
    params,
  });
};

const getCustomersList = (params) => {
  return requestrApi({
    url: "line_customers/listing_line_customers",
    mathod: "GET",
    params,
  });
};
const getAllCustomersList = (params) => {
  return requestrApi({
    url: "/purchase_orders/fetch_dependencies",
    mathod: "GET",
    params,
  });
};
const getSmsFormDependencies = (params) => {
  return requestApi({
    url: "sms/mysms/sms_report_form_dependencies",
    mathod: "GET",
    params,
  });
};

const createSMSReport = (formData) => {
  return requestApi({
    url: "sms/mysms/smsreport",
    method: "POST",
    data: formData,
  });
};
const createInjuryReport = (formData) => {
  return requestApi({
    url: "sms/mysms/injuryreport",
    method: "POST",
    data: formData,
  });
};
const createMgmtchangereport = (formData) => {
  return requestApi({
    url: "sms/mysms/mgmtchangereport",
    method: "POST",
    data: formData,
  });
};

const getProgressCategorisationList = (params) => {
  return requestApi({
    url: "sms/categorisation_list",
    mathod: "GET",
    params,
  });
};

const getProgressTasksList = (params) => {
  return requestApi({
    url: "sms/tasks_list",
    mathod: "GET",
    params,
  });
};

const getSmsInputDetails = (params) => {
  return requestApi({
    url: "sms/get_sms_input_details",
    mathod: "GET",
    params,
  });
};

const getSmsTaskDetails = (params) => {
  return requestApi({
    url: "sms/get_sms_task_details",
    mathod: "GET",
    params,
  });
};

const getSmsClosureHistory = (params) => {
  return requestApi({
    url: "sms/closure_history",
    mathod: "GET",
    params,
  });
};

const getSmsDueDateHistory = (params) => {
  return requestApi({
    url: "sms/due_date_history",
    mathod: "GET",
    params,
  });
};

const getUsersList = (params) => {
  return requestApi({
    url: "/fetch_users",
    method: "GET",
    params: params,
  });
};

const createTask = (formData) => {
  return requestApi({
    url: "sms/inputs/add_tasks",
    method: "POST",
    data: formData,
  });
};

const updateTask = (formData) => {
  return requestApi({
    url: "sms/inputs/update_tasks?_method=PUT",
    method: "POST",
    data: formData,
  });
};

const getHistoryList = (params) => {
  return requestApi({
    url: "sms/inputs/list_history_tasks",
    method: "GET",
    params: params,
  });
};

const getTaskDetailData = (params) => {
  return requestApi({
    url: "sms/inputs/get_task_detail",
    method: "GET",
    params: params,
  });
};

const getTaskTableData = (params) => {
  return requestApi({
    url: "sms/inputs/list_input_detail_tasks",
    method: "GET",
    params: params,
  });
};

const submitSmsInputClosure = (formData) => {
  return requestApi({
    url: "sms/inputs/add_sms_input_closure",
    method: "POST",
    data: formData,
  });
};

const acceptTask = (formData) => {
  return requestApi({
    url: "sms/tasks/accept_task",
    method: "POST",
    data: formData,
  });
};

const reOpenTask = (formData) => {
  return requestApi({
    url: "sms/tasks/reopen_task",
    method: "POST",
    data: formData,
  });
};

const reOpenInput = (formData) => {
  return requestApi({
    url: "sms/inputs/reopen_input",
    method: "POST",
    data: formData,
  });
};

const reviseDueDate = (formData) => {
  return requestApi({
    url: "sms/revise_duedate",
    method: "POST",
    data: formData,
  });
};

const deleteTask = (formData) => {
  return requestApi({
    url: "sms/tasks/delete_task",
    method: "DELETE",
    params: formData,
  });
};

const deleteInput = (formData) => {
  return requestApi({
    url: "sms/inputs/delete_input",
    method: "DELETE",
    params: formData,
  });
};

const saveAndCompleteTask = (formData) => {
  return requestApi({
    url: "sms/tasks/save_and_complete_task",
    method: "POST",
    data: formData,
  });
};

const fetchApprovalTypes = (params) => {
  return requestApi({
    url: "/fetch_approval_types",
    method: "GET",
    params: params,
  });
};
const fetchAircraftTypes = (params) => {
  return requestApi({
    url: "/planned_aircraft",
    method: "GET",
    params: params,
  });
};

const storeInitialAssessmentInput = (formData) => {
  return requestApi({
    url: "sms/inputs/add_initial_assessment",
    method: "POST",
    data: formData,
  });
};

const storeResidualAssessmentInput = (formData) => {
  return requestApi({
    url: "sms/inputs/add_residual_assessment",
    method: "POST",
    data: formData,
  });
};

const storeResidualAssessmentTask = (formData) => {
  return requestApi({
    url: "sms/tasks/add_residual_assessment",
    method: "POST",
    data: formData,
  });
};

const listInputMessages = (params) => {
  return requestApi({
    url: "sms/inputs/list_messages",
    method: "GET",
    params: params,
  });
};

const listBowTieMapping = (params) => {
  return requestApi({
    url: "sms/admin/list_bowtie_mapping",
    method: "GET",
    params: params,
  });
};

const listEventsThreatsAndBarriers = (params) => {
  return requestApi({
    url: "sms/get_events_threats_barriers_list",
    method: "GET",
    params: params,
  });
};

const checkBarrier = (formData) => {
  return requestApi({
    url: "sms/inputs/check_barriers",
    method: "POST",
    data: formData,
  });
};

const checkBarrierAdmin = (formData) => {
  return requestApi({
    url: "sms/admin/check_barriers",
    method: "POST",
    data: formData,
  });
};

const checkThreatAdmin = (formData) => {
  return requestApi({
    url: "sms/admin/check_treats",
    method: "POST",
    data: formData,
  });
};

const getOverviewIndicatorData = (params) => {
  return requestApi({
    url: "sms/inputs/overview_indicator",
    method: "GET",
    params: params,
  });
};

const getInputOverviewTableData = (params) => {
  return requestApi({
    url: "sms/inputs/overview_list",
    method: "GET",
    params: params,
  });
};

const getListInputsTableData = (params) => {
  return requestApi({
    url: "sms/inputs/list_inputs",
    method: "GET",
    params: params,
  });
};

const getTasksOverviewIndicatorData = (params) => {
  return requestApi({
    url: "sms/tasks/overview_indicator",
    method: "GET",
    params: params,
  });
};

const getTasksOverviewTableData = (params) => {
  return requestApi({
    url: "sms/tasks/overview_list",
    method: "GET",
    params: params,
  });
};

const getListTasksTableData = (params) => {
  return requestApi({
    url: "sms/tasks/list_tasks",
    method: "GET",
    params: params,
  });
};

const updateExternalAcceptance = (formData) => {
  return requestApi({
    url: "sms/inputs/external_acceptance?_method=PUT",
    method: "POST",
    data: formData,
  });
};

const addFinding = (formData) => {
  return requestApi({
    url: "sms/inputs/add_findings",
    method: "POST",
    data: formData,
  });
};
const emailReports = (formData) => {
  return requestApi({
    url: "sms/email_reports",
    method: "POST",
    data: formData,
  });
};

const getSMSSettings = (params) => {
  return requestApi({
    url: "sms/admin/get_sms_settings",
    method: "GET",
    params: params,
  });
};

const getSMSInputClosureMessages = (params) => {
  return requestApi({
    url: "sms/inputs/sms_input_closure_messages",
    method: "GET",
    params: params,
  });
};

const getRegulations = (params) => {
  return requestApi({
    url: "sms/get_regulations",
    method: "GET",
    params: params,
  });
};

const listBowTieItems = (params) => {
  return requestApi({
    url: "sms/admin/list_bowtie_items",
    method: "GET",
    params: params,
  });
};

const addBowtieItems = (formData) => {
  return requestApi({
    url: "sms/admin/add_bowtie_items",
    method: "POST",
    data: formData,
  });
};

const updateBowtieItems = (formData) => {
  return requestApi({
    url: "sms/admin/update_bowtie_items?_method=PUT",
    method: "POST",
    data: formData,
  });
};

const toggleDeleteBowtieItems = (formData) => {
  const dynamicString =
    formData?.get("id") && formData?.get("type")
      ? `?id=${formData?.get("id")}&type=${formData?.get("type")}`
      : "";

  return requestApi({
    url: `sms/admin/achieve_unachieve_item${dynamicString}`,
    method: "DELETE",
    data: formData,
  });
};

const listUserRiskLevels = (params) => {
  return requestApi({
    url: "sms/admin/list_user_risks",
    method: "GET",
    params: params,
  });
};

const addUserRiskLevels = (formData) => {
  return requestApi({
    url: "sms/admin/store_user_risk",
    method: "POST",
    data: formData,
  });
};

const deleteUserRiskLevels = (formData) => {
  const dynamicString = formData?.get("id") ? `?id=${formData?.get("id")}` : "";
  return requestApi({
    url: `sms/admin/delete_user_risk${dynamicString}`,
    method: "DELETE",
    data: formData,
  });
};

const storeReportableDefinitionPdf = (formData) => {
  return requestApi({
    url: "sms/admin/store_reportable_difinition_pdf",
    method: "POST",
    data: formData,
  });
};

const updateSMSOrganisationSettings = (formData) => {
  return requestApi({
    url: "sms/admin/update_sms_organisation_settings?_method=PUT",
    method: "POST",
    data: formData,
  });
};

const MySmsServices = {
  fetchAircraftTypes,
  updateSMSOrganisationSettings,
  storeReportableDefinitionPdf,
  deleteUserRiskLevels,
  addUserRiskLevels,
  listUserRiskLevels,
  checkBarrierAdmin,
  checkThreatAdmin,
  toggleDeleteBowtieItems,
  updateBowtieItems,
  addBowtieItems,
  listBowTieItems,
  getRegulations,
  getSMSInputClosureMessages,
  listEventsThreatsAndBarriers,
  emailReports,
  getSMSSettings,
  addFinding,
  updateExternalAcceptance,
  getTasksOverviewTableData,
  getListTasksTableData,
  getTasksOverviewIndicatorData,
  getListInputsTableData,
  getInputOverviewTableData,
  getOverviewIndicatorData,
  checkBarrier,
  listBowTieMapping,
  listInputMessages,
  storeInitialAssessmentInput,
  storeResidualAssessmentInput,
  storeResidualAssessmentTask,
  reviseDueDate,
  deleteInput,
  deleteTask,
  reOpenInput,
  fetchApprovalTypes,
  getCustomersList,
  getRegulatorsList,
  saveAndCompleteTask,
  reOpenTask,
  acceptTask,
  submitSmsInputClosure,
  getTaskTableData,
  getTaskDetailData,
  getHistoryList,
  createTask,
  updateTask,
  getUsersList,
  getSmsTaskDetails,
  getSmsDueDateHistory,
  getSmsClosureHistory,
  getSmsInputDetails,
  getBaseStation,
  getReportsTableData,
  getHeaderOverviewData,
  getSmsFormDependencies,
  createSMSReport,
  createInjuryReport,
  createMgmtchangereport,
  getInputsTableData,
  getManagedTasksTableData,
  getTasksTableData,
  getProgressCategorisationList,
  getProgressTasksList,
  getAllCustomersList
};

export default MySmsServices;
